import TitleInput from "Components/Common/Input/TextBoxes/TitleInput/TitleInput";
import MediaUpload from "Components/Common/MediaUpload/MediaUpload";
import ContentView from "Components/ContentView/ContentView";
import i18n from "i18next";
import { ChecklistTemplate } from "Models/Checklists/ChecklistTemplate";
import * as React from "react";
import styles from "./ChecklistTemplateInfo.scss";

interface IProps {
    checklistTemplate: ChecklistTemplate;
    onChange?: (name: string, isMediaChanged: boolean, pictureFile?: File) => void;
}

interface IState {
    name: string;
    checklistTemplateId: number | undefined;
    isNameFocussed: boolean;
    pictureFile?: File;
}

export class ChecklistTemplateInfo extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            name: props.checklistTemplate.name,
            checklistTemplateId: props.checklistTemplate.id,
            isNameFocussed: false
        };

        this.onNameChanged = this.onNameChanged.bind(this);
        this.onMediaChanged = this.onMediaChanged.bind(this);
    }

    public onNameChanged(newValue: string) {
        this.setState({ name: newValue });

        if (this.props.onChange) {
            this.props.onChange(newValue, false, this.state.pictureFile);
        }
    }

    public onMediaChanged(state: { imageFile?: File, videoFile?: File, videoThumbnailFile?: File }): void {
        this.setState({ pictureFile: state.imageFile });

        if (this.props.onChange) {
            this.props.onChange(this.state.name, true, state.imageFile);
        }
    }

    public static getDerivedStateFromProps(nextProps: IProps, prevState: IState): Partial<IState> {
        const partialState: Partial<IState> = {};

        if (nextProps.checklistTemplate && nextProps.checklistTemplate.id !== prevState.checklistTemplateId) {
            partialState.checklistTemplateId = nextProps.checklistTemplate.id;
            partialState.name = nextProps.checklistTemplate.name;
        }

        return partialState;
    }

    public render() {
        return (
            <ContentView>
                <div className={styles.checklistTemplateInfo}>
                    <div className={styles.info}>
                        {this.props.checklistTemplate.id ? (
                            <div className={styles.checklistTemplateId}>{i18n.t("checklists.properties.checklistId")}: {this.state.checklistTemplateId}</div>
                        ) : (
                                <div className={styles.checklistTemplateId}>{i18n.t("checklists.newChecklist")}</div>
                            )}
                        <TitleInput value={this.state.name} onChange={this.onNameChanged} placeholder={i18n.t("checklists.placeholders.checklistTitle")} />
                    </div>
                    <div className={styles.media}>
                        <MediaUpload
                            imageUrl={this.props.checklistTemplate.pictureUrl}
                            onChange={this.onMediaChanged}
                            isImageUploadOnly={true} />
                    </div>
                </div>
            </ContentView>
        );
    }
}


// WEBPACK FOOTER //
// ./src/Components/Pages/ChecklistTemplateDetailView/ChecklistTemplateInfo/ChecklistTemplateInfo.tsx